import {NgModule} from '@angular/core';
import {CmsConfig, provideConfig} from '@spartacus/core';

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        search: {
          module: () => import('../../../search/search.module').then((m) => m.SearchModule),
          cmsComponents: [
            'SearchResultsGridComponent',
            'SearchCustomResultListComponent',
            'SearchCustomPaginationComponent',
            'SearchCustomSortingComponent',
            'HeadlessCommerceSearchWebComponent',
          ],
        },
      },
    } as CmsConfig),
  ],
})
export class SearchFeatureModule {}
